export const deleteExperience = ({BeURL ,id}) => {
    fetch(`${BeURL}/candidate-experience-delete/${id}`, {
        method: "DELETE",
        credentials: 'include'
    })
        .then(res => res.json())
        .then(data => {
            if (data.success) {
                alert(data.message)
            }
            else {
                alert(data.message)
            }
        })
        .catch(err => {
            console.log("Error to Delete candidate experience", err)
        })
}
